import { Box } from "@mui/material";
import React from "react";

export default function CoreButtonContainer(props) {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        width: "100%",
        marginTop: 20,
        ...props.style,
      }}
    >
      {props.children}
    </Box>
  );
}
